import { Card, Grid, Tab, Tabs } from "@mui/material";
import DashboardLayout from "layouts/DashboardLayout/DashboardLayout";
import { useState } from "react";
import CreateAdvisorModal from "../CreateAdvisorModal";
import Advisor from "./Advisor";
import Investor from "./Investor";

const User = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [advisorCreateModal, setAdvisorCreateModal] = useState(false);

  const profileTabs = ["Advisor", "Investor"];

  return (
    <DashboardLayout
      title="User"
      breadcrumbs={[
        {
          name: "User",
          path: "user",
        },
      ]}
    >
      <Card>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Tabs
              variant="fullWidth"
              value={activeTab}
              onChange={(e, val) => setActiveTab(val)}
            >
              {profileTabs.map((dataItem, index) => (
                <Tab key={index} label={dataItem} />
              ))}
            </Tabs>
          </Grid>
          <Grid item xs={12}>
            {activeTab === 0 && <Advisor />}
            {activeTab === 1 && <Investor />}
          </Grid>
        </Grid>
      </Card>
      {advisorCreateModal && (
        <CreateAdvisorModal
          open={advisorCreateModal}
          setOpen={setAdvisorCreateModal}
          // refetch={refetch}
        />
      )}
    </DashboardLayout>
  );
};

export default User;
